import { extend } from '../vue';

// --- Mixin ---

// @vue/component
const useParentMixin = extend({
  computed: {
    bvParent() {
      return this.$parent || this.$root === this && this.$options.bvParent;
    }
  }
});

export { useParentMixin };
